import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import Icon from 'shared/components/Icon';
import { Currency } from '../Currency';
import { ActivityType } from 'shared/models';

export type ChargeStatusProps = {
  showChargeStatus: boolean;
  transaction: Transaction;
  type: any;
};

type Transaction = {
  amount: number;
  amountOfChargePaid: number;
  id: string;
};

export function ChargeStatus(props: ChargeStatusProps) {
  const { showChargeStatus, transaction, type } = props;
  const { amount, amountOfChargePaid, id } = transaction;

  const renderStatus = () => {
    if (amountOfChargePaid === null || !showChargeStatus) {
      return null;
    }

    if (amountOfChargePaid === 0 && amount !== 0) {
      return (
        <div id={`transaction-status-${id}`}>
          <Icon className="text-danger mr-1" icon="error" />
          <UncontrolledTooltip placement="right" target={`transaction-status-${id}`}>
            This charge has no payments.
          </UncontrolledTooltip>
        </div>
      );
    } else if (amountOfChargePaid < amount) {
      return (
        <div id={`transaction-status-${id}`}>
          <Icon className="text-warning mr-1" icon="warning" />
          <UncontrolledTooltip placement="right" target={`transaction-status-${id}`}>
            This charge has a partial payment of <Currency amount={amountOfChargePaid} />.
          </UncontrolledTooltip>
        </div>
      );
    } else if (amountOfChargePaid === amount || amount === 0) {
      return (
        <div id={`transaction-status-${id}`}>
          <Icon className="text-success mr-1" icon="check_circle" />
          <UncontrolledTooltip placement="right" target={`transaction-status-${id}`}>
            This charge is fully paid.
          </UncontrolledTooltip>
        </div>
      );
    }

    return null;
  };
  if (type === ActivityType.Charge && transaction.amount !== null) {
    return (
      <span className="inline-popover">
        {renderStatus()}
        <Currency amount={amount} />
      </span>
    );
  }

  return null;
}
